package org.example.project

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ExitToApp
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.FilterQuality
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import kotlinx.coroutines.CoroutineStart
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource

// Corporate Color Palette
val PrimaryColor = Color(0xFF0F172A) // Slate 900
val AccentColor = Color(0xFF3B82F6)  // Blue 500
val BackgroundColor = Color(0xFFF8FAFC) // Slate 50
val SurfaceColor = Color.White

@Composable
fun App() {
    val scope = rememberCoroutineScope()
    MaterialTheme(
        colorScheme = lightColorScheme(
            primary = PrimaryColor,
            secondary = AccentColor,
            background = BackgroundColor,
            surface = SurfaceColor,
            onPrimary = Color.White,
            onSurface = PrimaryColor
        )
    ) {
        var showLoginDialog by remember { mutableStateOf(false) }
        var userEmail by remember { mutableStateOf<String?>(null) }
        var currentScreen by remember { mutableStateOf("Home") }

        val authState by FirebaseManager.authState.collectAsState()
        val isLoggedIn = authState == AuthState.LOGGED_IN

        // Fetch backend data whenever the user logs in
        LaunchedEffect(authState) {
            if (authState == AuthState.LOGGED_IN) {
                val email = FirebaseManager.getCurrentUserEmail()
                if (email != null) {
                    userEmail = email
                    FirebaseManager.syncWithBackend()
                }
            } else if (authState == AuthState.LOGGED_OUT) {
                userEmail = null
            }
        }

        Box(modifier = Modifier.fillMaxSize()) {
            if (currentScreen == "Settings") {
                SettingsPage(
                    userEmail = userEmail,
                    onBackClick = { currentScreen = "Home" }
                )
            } else {
                Scaffold(
                    topBar = {
                        Header(
                            isLoggedIn = isLoggedIn,
                            userEmail = userEmail,
                            onLoginClick = { showLoginDialog = true },
                            onLogoutClick = {
                                scope.launch {
                                    FirebaseManager.signOut()
                                    // State changes are now handled by AuthState listener
                                }
                            },
                            onSettingsClick = { currentScreen = "Settings" }
                        )
                    }
                ) { paddingValues ->
                    BoxWithConstraints(
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(paddingValues)
                            .background(BgWhite)
                    ) {
                        val isMobile = maxWidth < 800.dp
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .verticalScroll(rememberScrollState()),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            HeroSection(isMobile)
                            DemoSection(isMobile)
                            HorizontalDivider(color = BorderColor)
                            FeaturesSection(isMobile)
                            HorizontalDivider(color = BorderColor)
                            PricingSection(isMobile)
                            UseCasesSection(isMobile)
                            FAQSection(isMobile)
                            Footer()
                        }
                    }
//                    Column(
//                        modifier = Modifier
//                            .fillMaxSize()
//                            .background(MaterialTheme.colorScheme.background)
//                            .padding(innerPadding)
//                            .verticalScroll(rememberScrollState())
//                    ) {
//                        HeroSection()
//                        TrustedBySection()
//                        FeaturesSection()
//                        TechnologySection()
//                        TestimonialsSection()
//                        DemoSection()
//                        Footer()
//                    }
                }
            }

            if (showLoginDialog) {
                LoginOverlay(
                    onDismiss = { showLoginDialog = false },
                    onLoginSuccess = {
                        showLoginDialog = false
                        // The LaunchedEffect(authState) will trigger syncWithBackend automatically
                    }
                )
            }
        }
    }
}
